import React from "react";
import { Text, View } from "react-native";
import tw from "twrnc";

import IconButton from "@/components/settings/IconButton";
import { colors, text } from "@/components/settings/theme";
import { t } from "@/localization";

const GuestListItem = ({ guest, onDelete }) => {
  return (
    <View
      style={[
        tw`flex-row items-center py-3`,
        { borderBottomWidth: 1, borderBottomColor: colors.divider },
      ]}
    >
      <View style={tw`flex-1 mr-3`}>
        {!!guest.name && (
          <Text style={text.bodyStrong} numberOfLines={1}>
            {guest.name}
          </Text>
        )}
        {!!guest.email && (
          <Text style={text.hint} numberOfLines={1}>
            {guest.email}
          </Text>
        )}
      </View>
      {!!guest.status && (
        <View style={tw`flex-shrink-0 mr-2`}>
          <Text
            numberOfLines={1}
            style={[
              tw`px-2 py-0.5 rounded-full text-[12px] leading-[18px] font-semibold text-white overflow-hidden`,
              { backgroundColor: guest.color },
            ]}
          >
            {guest.status}
          </Text>
        </View>
      )}
      {!!onDelete && (
        <IconButton
          icon="trash-outline"
          label={t("Remove {guest} from the guest list", {
            guest: guest.name || guest.email,
          })}
          onPress={onDelete}
        />
      )}
    </View>
  );
};

export default GuestListItem;
